// extracted by mini-css-extract-plugin
module.exports = {"theme":"#1890ff"};
    if(module.hot) {
      // 1793421716506
      var cssReload = require("/private/workspaces/smart-life/smart-life-admin/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../../","locals":true});
      module.hot.dispose(cssReload);
      
    }
  